import React from 'react';

import TalkBase from '../_talk';
import talk from './testing-javascript-mocha-chai.json';

export default () => <TalkBase talk={talk} />;



// WEBPACK FOOTER //
// ./pages/talks/testing-javascript-mocha-chai/index.js